export default "__VITE_ASSET__vjiEqqQk__"